import React from 'react';
import {
  ExpandableCardsSection,
  ExpandableCardsContainer,
  TitleSection,
} from './styled.detailSkeleton';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export function DetailSkeleton () {
  return (
    <>
      <TitleSection>
        <div>
          <Skeleton width={100} />
        </div>
        <div>
          <Skeleton width={80} />
        </div>
      </TitleSection>
      <ExpandableCardsSection>
        <ExpandableCardsContainer>
          <div>
            <Skeleton width={80} />
          </div>
          <div>
            <Skeleton width={20} />
          </div>
        </ExpandableCardsContainer>
      </ExpandableCardsSection>
    </>
  );
}
